

import setTokenHeader from './setTokenInHeader';
import { updateProps } from './global';
import { Iuser, IUserLogin } from '../types/user';
import { Endpoints } from './endpoint';
import axiosInstance, { CustomAxiosRequestConfig } from '../services/axios';


export const userRegisterApi=async(payload:Partial<Iuser>)=>{
        const res=await axiosInstance.post(
            `${process.env.NEXT_PUBLIC_API}${Endpoints.USER.REGISTER}`,
            payload
        );
        return res.data;
    
}
export const userUpdateApi=async({id,payload}:updateProps<Iuser>)=>{
    await setTokenHeader();
    const res=await axiosInstance.put(
        `${process.env.NEXT_PUBLIC_API}${Endpoints.USER.UPDATE}/${id}`,
        payload
    );
    return res.data;

}

export const userLoginApi = async (payload: Partial<IUserLogin>) => {
    const res = await axiosInstance.post(
        `${process.env.NEXT_PUBLIC_API}${Endpoints.AUTH.LOGIN}`,
        payload,
        {
            requiresAuth: false // Custom property to skip auth
        } as CustomAxiosRequestConfig
    );
    return res.data;
};

export const userMeApi = async () => {
    const res = await axiosInstance.get(
        `${process.env.NEXT_PUBLIC_API}${Endpoints.AUTH.ME}`,
        {
            requiresAuth: true // Custom property to skip auth
        } as CustomAxiosRequestConfig
    );
    return res.data;
};
